import { render, staticRenderFns } from "./MailboxManage.vue?vue&type=template&id=7032c7c7&scoped=true&"
import script from "./MailboxManage.vue?vue&type=script&lang=js&"
export * from "./MailboxManage.vue?vue&type=script&lang=js&"
import style0 from "./MailboxManage.vue?vue&type=style&index=0&id=7032c7c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032c7c7",
  null
  
)

export default component.exports